import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {destinosModuleName, destinosStorage} from "../shared/data.service";
import {Destino} from "../shared/destino.model";
import {editRoute, newRoute, configuracaoModuleName} from "../../../shared/services/data.service";
import {DestinoNavigationService} from "../shared/destino-navigation.service";
import {DestinoApiService} from "../shared/destino-api.service";
import {DestinoService} from "../shared/destino.service";
import {UtilService} from "../../../shared/services/util.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {viagensModuleName} from "../../shared/data.service";
import {ViagemService} from "../../shared/viagem.service";

@Component({
    template: require('./destino-form.component.html'),
    styles: [require('./destino-form.component.css')]
})
export class DestinoFormComponent implements OnInit {
    destinosModule: any = destinosModuleName;
    formObject: any = new Destino();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    configuracaoModule: any = configuracaoModuleName;
    module: any = viagensModuleName;

    form: FormGroup;
    ativo = new FormControl('');
    destino = new FormControl('', Validators.required);
    observacao = new FormControl('');

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseDestino: any;

    constructor(
        private _route: ActivatedRoute,
        private _destinoNavigationService: DestinoNavigationService,
        private _destinoApiService: DestinoApiService,
        private _destinoService: DestinoService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _viagemService: ViagemService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            destino: this.destino,
            observacao: this.observacao
        });
    }

    ngOnInit() {
        this.isNewAutoComplete();
    }

    clickGoToConfig() {
        this._viagemService.goToSetting()
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object:Destino = this._utilService.cloneObject(this.formObject);

            if (this.formObject.id) {
                this.onEditDestino(object);
            } else {
                this.onAddDestino(object);
            }
        }
    }

    private onAddDestino(object: Destino) {
        this._destinoApiService.onPost(object, this.onDone);
    }

    private onEditDestino(object: Destino) {
        this._destinoApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responseDestino = Response;

            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();

        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum destino encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._destinoApiService.onGetById(id, onDone);
    }

    private testSession() {
        let id: number;
        let session: any = this._destinoService.getSessionStorage();
        this._destinoService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._destinoService.returnToOtherForm(this.otherForm, this.responseDestino);
        } else {
            this.goToList();
        }
    }

    private goToList() {
        this._destinoNavigationService.goToList();
    }

    private isNewAutoComplete() {
        let newAutoComplete: any = this._autocompleteService.getSessionStorage(destinosStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.destino = newAutoComplete.destino;

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private setModelToForm() {

    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/destinos/destino-form/destino-form.component.ts
 **/